import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import { FormattedMessage } from "react-intl";
import MessageTypeIcon from "../../../../../../components/MessageTypeIcon";
import { processesService } from "../../../../Services";
import { IntlMessage } from "../../../../../../components/Intl";
const ProcessMessagesDialog = (props) => {
  const { open, batchId, handleClose } = props;
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const getMessages = useCallback(async () => {
    const response = await processesService.getProcessItem(batchId);
    setMessages(response.data.messages);
    setLoading(false);
  }, [batchId]);
  useEffect(() => {
    getMessages();
  }, [getMessages]);
  return /* @__PURE__ */ React.createElement(Dialog, { open, onClose: () => handleClose(), fullWidth: true, maxWidth: "md", "aria-labelledby": "process-messages-dialog" }, /* @__PURE__ */ React.createElement(DialogTitle, { id: "process-messages-dialog" }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connection.processes.errorMessages.dialogTitle" })), /* @__PURE__ */ React.createElement(DialogContent, null, loading && /* @__PURE__ */ React.createElement(LinearProgress, null), /* @__PURE__ */ React.createElement(List, null, (messages || []).map((message) => /* @__PURE__ */ React.createElement(ListItem, { key: message.description }, /* @__PURE__ */ React.createElement(ListItemIcon, null, /* @__PURE__ */ React.createElement(MessageTypeIcon, { messageType: message.messageType })), /* @__PURE__ */ React.createElement(
    ListItemText,
    {
      primary: /* @__PURE__ */ React.createElement(FormattedMessage, { id: `connection.processes.errorMessages.${message.messageType}` }),
      secondary: message.description
    }
  ))))), /* @__PURE__ */ React.createElement(DialogActions, null, /* @__PURE__ */ React.createElement(Button, { variant: "contained", onClick: () => handleClose(), color: "secondary" }, /* @__PURE__ */ React.createElement(IntlMessage, { value: "close" }))));
};
ProcessMessagesDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  batchId: PropTypes.string
};
export default ProcessMessagesDialog;
